module.exports = __webpack_public_path__ + "img/history.eea092ee.png";